// extracted by mini-css-extract-plugin
export default {"main":"HomePc_main__BbU2i","content":"HomePc_content__r0mZx","breadCrumb":"HomePc_breadCrumb__fgaOo","headerItem":"HomePc_headerItem__U2CaU"};